import {useState} from 'react'
import {redClock, bigClose} from '@img/index.js'

// Pending-payment alert shown as a popover sitting just above the "Your Next Ride"
// card (home + ride details), with a downward arrow pointing into it — mirroring the
// "Square hold funds and charge after drop-off" payment tooltip. Parent must be
// position: relative.
export default function AlertMessage({paymentHold}) {
    const [dismissed, setDismissed] = useState(false)
    const shouldShow = paymentHold?.is_authorized === false || paymentHold?.is_captured === false
    if (!shouldShow || dismissed) return null

    return (
        <div className="absolute z-20 left-10 max-md:left-0 bottom-full w-[calc(100%-2rem)] max-w-[385px]">
            <div className="relative bg-[#f07171] rounded-2xl px-3 py-2.5 shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
                <div className="flex items-center gap-3">
                    <span className="shrink-0">
                        <img src={redClock} alt="clock" className="brightness-0"/>
                    </span>
                    <p className="mb-0! font-semibold text-(--text-primary)">Your ride will remain pending until payment is successfully authorized</p>
                    <button type="button"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDismissed(true) }}
                            className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full cursor-pointer"
                            aria-label="Close">
                        <img src={bigClose} alt="Close"/>
                    </button>
                </div>
                <span className="absolute -bottom-6 max-md:-bottom-4 left-[3%] max-md:left-[10%] w-0 h-0 border-l-0 border-r-40 max-md:border-r-30 border-r-transparent border-t-30 max-md:border-t-25 border-t-[#f07171]"></span>
            </div>
        </div>
    )
}
